<template>
  <div>
    <v-server-table id="table-decomptes_ij" ref="decomptes_ij_table" :columns="columns" :options="options">
      <div slot="salarie" slot-scope="props" class="formatted-box">
        <b>{{ props.row.nom_pp }} {{ props.row.prenom_pp }}</b> <br>
        <span style="color: #2139ff;">{{ props.row.nir_pp }}</span>
      </div>
      <div slot="categorie" slot-scope="props" class="formatted-box">
        <span v-if="props.row.cat_sal"><b>{{ props.row.cat_sal }}</b></span>
        <span v-else><b>N.D.</b></span> <br>
        <span>NIC : {{ Number(props.row.siret_pm_site.substring(props.row.siret_pm_site.length - 5)) }}</span>
        <i :id="`tooltip-${props.row.presta_id}`" class="fa fa-info clickable ml-4"></i>
        <b-tooltip :target="`tooltip-${props.row.presta_id}`" triggers="hover">
          <span>{{ props.row.raison_sociale }}</span><br>
          {{ getFormattedSiret(props.row.siret_pm_site) }}
        </b-tooltip>
      </div>
      <div slot="periode_arret" slot-scope="props" class="formatted-box">
        du {{ formatDate(props.row.date_deb_prest) }} <br>
        au {{ formatDate(props.row.date_fin_prest) }}
      </div>
      <div slot="nature" slot-scope="props" class="formatted-box">
        {{ props.row.lib_cause }} <br>
        <span>{{ props.row.nb_jour }} j.</span>
      </div>
      <div slot="produit" slot-scope="props" class="formatted-box">
        <b>{{ props.row.produit }}</b> <br>
        <i>{{ props.row.lib_gar }}</i>
      </div>
      <div slot="prise_en_charge" slot-scope="props" class="formatted-box">
        <i>{{ getPriseEnCharge(props.row.prise_en_charge, props.row.lib_type_prest) }} </i><br>
        <span v-if="props.row.total_presta > 0"> <b>+ {{ formatNumber(props.row.total_presta) }} €</b></span>
        <span style="color:#ce0b35" v-else-if="props.row.total_presta < 0"><b>{{ formatNumber(props.row.total_presta) }} €</b></span>
        <span v-else> - </span>
      </div>
      <div slot="date_traitement" slot-scope="props" class="formatted-box">
        {{ formatDate(props.row.date_traitement) }} <br>
        <span style="color: #2139ff;">{{ props.row.num_decompte }}</span>
      </div>
      <div slot="action" slot-scope="props" class="formatted-box">
        <img style="width: 15px;" class="mr-2 clickable" :src="getIcon('pdf')" @click="downloadPDF(props.row.num_decompte, props.row.decompte_id)">
        <!-- <i v-if="isNotArchive(props.row,'prestation')" v-b-tooltip.hover title="Archiver" class="fa fa-folder clickable text-warning" @click="updateStatus('prestation', 'archive', props.row.presta_id)"></i>
        <i v-else v-b-tooltip.hover title="Désarchiver" class="fa fa-folder-open clickable text-secondary" @click="updateStatus('prestation', 'a_traiter', props.row.presta_id)"></i> -->
        <br>
        <span style="font-size: 13px"><i>Période {{ getLibelleStatutPrestation(props.row) }}</i></span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
  import {formatDate, formatNumber} from "@/utils/communHelper";
  import {isEmpty, getFileIcon, downloadFile} from "@/utils/fileHelper";

  export default {
    name: "DecomptesIj",
    data() {
      let self = this;
      return {
        columns: ['salarie', 'categorie', 'periode_arret', 'nature', 'produit', 'prise_en_charge', 'date_traitement', 'action'],
        url: '',
        // noSearch: '',
        options: {
          headings: {
            'salarie': 'Nom Prénom \nNIR',
            'categorie': 'Catégorie \nAffiliation',
            'periode_arret': "Période d'arrêt",
            'nature': 'Nature \nJours',
            'produit': 'Produit \nType Garantie',
            'prise_en_charge': 'Prise en charge \nMontant',
            'date_traitement': 'Date traitement \nN°décompte',
            'action': 'Action Période \nStatut Période',
          },
          columnsClasses: {
            salarie: 'pre-formatted sort-top position-r',
            categorie: 'pre-formatted sort-top position-r',
            periode_arret: 'pre-formatted sort-top position-r',
            nature: 'pre-formatted sort-top position-r',
            produit: 'pre-formatted sort-top position-r',
            date_traitement: 'pre-formatted sort-top position-r',
            prise_en_charge: 'pre-formatted sort-top position-r',
            action: 'pre-formatted sort-top text-center position-r',
          },
          sortable: ["date_traitement"],
          filterable: false,
          perPage: 10,
          perPageValues: [10, 25, 50],
          requestFunction: function (data) {
            // self.noSearch = '';
            // if (self.noSearch !== 'noSearch') {
            //   self.$store.commit('IS_LOADING', true);
            // }
            // console.log('dans le request', self.$refs['decomptes_ij_table'])
            if (!isEmpty(self.$refs['decomptes_ij_table'])) {
              self.$refs['decomptes_ij_table'].loading = true;
            }
            self.$event.emit('startLoadingDecompte');
            self.url = '/espaceGestion/dossier/getDecomptesDossier/' + self.dossier.id;
            return axios.get(self.url, {params: data})
            .then(function(response){
              // self.noSearch = 'noSearch';
              // self.$store.commit('IS_LOADING', false);
              self.$event.emit('stopLoadingDecompte');
              return response;
            })
            .catch(function (e) {
              // console.log(e);
              // self.$store.commit('IS_LOADING', false);
              self.$event.emit('stopLoadingDecompte');
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
          }
        },
        formatDate,
        formatNumber,
        isEmpty,
      };
    },
    props: ['dossier', 'allStatus'],
    mounted() {
      this.$event.on('refreshDecomptes', () => {
        this.$refs.decomptes_ij_table.refresh();
      });

      this.$event.on('startLoadingDecompte', () => {
        if (!isEmpty(this.$refs['decomptes_ij_table'])) {
          this.$refs['decomptes_ij_table'].data = [];
        }
      });
    },
    methods: {
      onLoaded(){
        this.$store.commit("IS_LOADING", false);
      },
      getPriseEnCharge(prise_en_charge, lib_type_prest) {
        if (prise_en_charge === '' && lib_type_prest.toLowerCase() === 'franchise') {
          prise_en_charge = 'Franchise';
        } else if (prise_en_charge === '') {
          prise_en_charge = lib_type_prest.toLowerCase();
        }
        return prise_en_charge;
      },
      getIcon(extension) {
        let images = require.context('../../../assets/images/', false, /^\.\/\S+.*\.[a-zA-Z]+$/);
        let extensionIcon = getFileIcon();
        return images('./' + extensionIcon[extension]);
      },
      getLibelleStatutPrestation(decompte) {
        let libelle = '';
        if (isEmpty(decompte.presta_statut_id)) {
          let statusPresta = _.find(this.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.statut_id,10));
          if (!isEmpty(statusPresta)) {
            libelle = statusPresta.libelle_bo;
          }
        } else {
          let statusPresta = _.find(this.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.presta_statut_id,10));
          if (!isEmpty(statusPresta)) {
            libelle = statusPresta.libelle_bo;
          }
        }

        return libelle;
      },
      getFormattedSiret(siret){
        if (siret.length === 9) {
          return siret.substring(0,3)+' '+siret.substring(3,3)+' '+siret.substring(6,3);
        } else {
          return siret.substring(0,9)+' - '+siret.substring(siret.length - 5);
        }
      },
      downloadPDF(numero_decompte, decompte_id) {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/decomptesIJ/generatePDF/' + decompte_id, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, 'decompte_' + numero_decompte, 'pdf');
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
    }
  };
</script>

<style scoped>
  .VueTables__search-field input {
    width: 240px !important;
  }
</style>
